import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a4cf1b7"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "users-list__header" };
const _hoisted_2 = { class: "card-group-title" };
const _hoisted_3 = { class: "users-list__header-actions" };
const _hoisted_4 = { class: "users-list__dropdown" };
const _hoisted_5 = {
    key: 0,
    class: "icon icon-down-14px"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "users-list__table" };
const _hoisted_8 = {
    key: 0,
    class: "users-list__table-overlay"
};
const _hoisted_9 = { class: "users-list__table-header" };
const _hoisted_10 = { class: "users-list__table-cell--highlight users-list__table-cell--ellipsis" };
const _hoisted_11 = { class: "users-list__table-header" };
const _hoisted_12 = { class: "users-list__table-cell users-list__table-cell--ellipsis" };
const _hoisted_13 = { class: "users-list__table-header" };
const _hoisted_14 = { class: "users-list__table-cell" };
const _hoisted_15 = { class: "users-list__table-header" };
const _hoisted_16 = { class: "users-list__table-cell-status" };
const _hoisted_17 = { class: "users-list__table-cell" };
const _hoisted_18 = {
    key: 0,
    class: "icon icon-menu-14px"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = { class: "users-list__table-empty" };
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
import ListPagination from '@/components/_atoms/ListPagination.vue';
import UserDialogErrorModal from '@/components/settings/users/UserDialogErrorModal.vue';
import UserQuestionModal from '@/components/settings/users/UserQuestionModal.vue';
import UserUnlockModal from '@/components/settings/users/UserUnlockModal.vue';
import TableColumnSearch from '@/components/TableColumnSearch.vue';
import { useUsersActions, useUsersExport, useUsersFilters, useUsersPagination, useUsersSorting, } from '@/features/Settings/Users/composables';
import { fetchUserList } from '@/features/Settings/Users/data/fetchUserList';
import bus from '@/helpers/events/bus';
import i18n from '@/i18n';
import store from '@/store';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { keepPreviousData, useQuery, useQueryClient } from '@tanstack/vue-query';
import { computed, onMounted, onUnmounted, watch } from 'vue';
import { useToast } from 'vue-toastification';
const STALE_TIME = 1000 * 60 * 60;
export default /*#__PURE__*/ _defineComponent({
    __name: 'UsersList',
    emits: ['open-create', 'open-edit'],
    setup(__props, { emit }) {
        const toast = useToast();
        const queryClient = useQueryClient();
        const loginWithPin = computed(() => !store.getters.hasSso);
        const selectedBrand = computed(() => store.getters.selectedBrand);
        const { id, pagination, resetPagination } = useUsersPagination();
        const { getOrderBy, currentSort, sortTable } = useUsersSorting();
        const { searchFields, statusFilter, filteredStatusValues, formatFilterValues, getEnabledValue, handleSearchTerm, clearSearchTerm, setStatusFilter, } = useUsersFilters(resetPagination);
        const { isExporting, exportUserList } = useUsersExport();
        const { disableUser, resetPassword, triggerConfirmModal, unlockUserModal, togglingUserId } = useUsersActions();
        const userListQueryKey = computed(() => createUserListQueryKey(pagination.page));
        function createUserListQueryKey(page) {
            return [
                'settings-users-list',
                {
                    page,
                    limit: pagination.limit,
                    orderBy: getOrderBy.value,
                    filters: formatFilterValues.value,
                    statusFilter: statusFilter.value,
                    brandId: selectedBrand.value?.id,
                },
            ];
        }
        async function createFetchUserListQuery(page) {
            const fetchParams = {
                page,
                limit: pagination.limit,
                orderBy: getOrderBy.value,
                filters: formatFilterValues.value,
                statusFilter: getEnabledValue.value(statusFilter.value),
            };
            return fetchUserList(fetchParams.filters, fetchParams.orderBy, fetchParams.page, fetchParams.limit, fetchParams.statusFilter);
        }
        const { data: userList, isPending: loading, isFetching, error: hasError, } = useQuery({
            queryKey: userListQueryKey,
            queryFn: () => createFetchUserListQuery(pagination.page),
            staleTime: STALE_TIME,
            placeholderData: keepPreviousData,
        });
        function reloadUsersList() {
            queryClient.invalidateQueries({ queryKey: ['settings-users-list'] });
        }
        function formatStatusLabel(enabled) {
            return enabled === 1 ? i18n.global.t('settings.users.enabled') : i18n.global.t('settings.users.disabled');
        }
        function filterChangeHandler(activeFilters) {
            const statusValues = activeFilters.status || [];
            const newStatusFilter = statusValues.length > 1 ? statusValues : statusValues[0] || 'active';
            resetPagination();
            setStatusFilter(newStatusFilter);
        }
        function exportUsers(fileType) {
            exportUserList(fileType);
        }
        function addNewUser() {
            useMixpanelConfig('settings-users_clicked_btn-create-user');
            emit('open-create');
        }
        function openEdit(user) {
            useMixpanelConfig('settings-users_clicked_btn-edit-user');
            emit('open-edit', user);
        }
        function isUserToggling(userId) {
            return togglingUserId.value === userId;
        }
        function getUserStatusClass(enabled) {
            return enabled === 1 ? 'active' : 'inactive';
        }
        watch(() => userList.value?.totalCount, newCount => {
            pagination.count = newCount;
        }, { immediate: true });
        onMounted(() => {
            bus.$on('update-users', mode => {
                reloadUsersList();
                if (mode) {
                    toast.success(i18n.global.t(`settings.users.${mode}.toast-success`), { timeout: 5000 });
                }
            });
            bus.$on('user-reset-password', () => {
                resetPassword();
            });
        });
        onUnmounted(() => {
            bus.$off('user-reset-password');
        });
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
            const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("header", _hoisted_1, [
                    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('settings.users.title')), 1),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_dropdown, { disabled: _unref(isExporting) }, {
                            dropdown: _withCtx(() => [
                                _createVNode(_component_el_dropdown_menu, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_dropdown_item, {
                                            onClick: _cache[0] || (_cache[0] = ($event) => (exportUsers('csv')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('export')) + " .CSV", 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            onClick: _cache[1] || (_cache[1] = ($event) => (exportUsers('xls')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('export')) + " .XLS", 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            onClick: _cache[2] || (_cache[2] = ($event) => (exportUsers('xlsx')))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('export')) + " .XLSX", 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_el_button, {
                                        loading: _unref(isExporting),
                                        class: "users-list__dropdown-button",
                                        round: "",
                                        size: "large"
                                    }, {
                                        default: _withCtx(() => [
                                            (!_unref(isExporting))
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$tc('_export', 2)), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["loading"])
                                ])
                            ]),
                            _: 1
                        }, 8, ["disabled"]),
                        (loginWithPin.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn users-list__btn-create-user",
                                "data-cy": "btn-user-create",
                                onClick: _withModifiers(addNewUser, ["prevent"])
                            }, _toDisplayString(_ctx.$t('settings.users.new-user')), 9, _hoisted_6))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    (_unref(isFetching))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(BaseLoader)
                        ]))
                        : _createCommentVNode("", true),
                    _createVNode(_component_el_table, {
                        data: _unref(userList)?.users,
                        "default-sort": _unref(currentSort),
                        class: _normalizeClass(['users-list__table-content', { 'users-list__table-content--loading': _unref(isFetching) }]),
                        "max-height": "3000",
                        stripe: "",
                        "table-layout": "auto",
                        onSortChange: _unref(sortTable),
                        onFilterChange: filterChangeHandler
                    }, {
                        empty: _withCtx(() => [
                            _createElementVNode("div", _hoisted_20, [
                                (!_unref(loading))
                                    ? (_openBlock(), _createBlock(InfoCard, { key: 0 }))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                                label: _ctx.$t('settings.users.name'),
                                prop: "name",
                                "show-overflow-tooltip": "",
                                sortable: "",
                                width: "200"
                            }, {
                                header: _withCtx(({ column }) => [
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(column.label), 1),
                                    _createVNode(TableColumnSearch, {
                                        searchTerm: _unref(searchFields).name,
                                        "onUpdate:nameSearch": searchString => _unref(handleSearchTerm)(searchString, column),
                                        "onClear:nameSearch": () => _unref(clearSearchTerm)(column)
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("i", {
                                                class: _normalizeClass([{ 'search-icon--active': _unref(searchFields).name }, "icon icon-search-12px"])
                                            }, null, 2)
                                        ]),
                                        _: 2
                                    }, 1032, ["searchTerm", "onUpdate:nameSearch", "onClear:nameSearch"])
                                ]),
                                default: _withCtx(({ row }) => [
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(row.name), 1)
                                ]),
                                _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                                label: _ctx.$t('settings.users.email'),
                                prop: "email",
                                "show-overflow-tooltip": "",
                                sortable: "",
                                width: "260"
                            }, {
                                header: _withCtx(({ column }) => [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(column.label), 1),
                                    _createVNode(TableColumnSearch, {
                                        searchTerm: _unref(searchFields).email,
                                        "onUpdate:nameSearch": searchString => _unref(handleSearchTerm)(searchString, column),
                                        "onClear:nameSearch": () => _unref(clearSearchTerm)(column)
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("i", {
                                                class: _normalizeClass([{ 'search-icon--active': _unref(searchFields).email }, "icon icon-search-12px"])
                                            }, null, 2)
                                        ]),
                                        _: 2
                                    }, 1032, ["searchTerm", "onUpdate:nameSearch", "onClear:nameSearch"])
                                ]),
                                default: _withCtx(({ row }) => [
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(row.email), 1)
                                ]),
                                _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                                label: _ctx.$t('settings.users.profile'),
                                prop: "profile",
                                sortable: "",
                                width: "140"
                            }, {
                                header: _withCtx(({ column }) => [
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(column.label), 1),
                                    _createVNode(TableColumnSearch, {
                                        searchTerm: _unref(searchFields).profile,
                                        "onUpdate:nameSearch": searchString => _unref(handleSearchTerm)(searchString, column),
                                        "onClear:nameSearch": () => _unref(clearSearchTerm)(column)
                                    }, {
                                        reference: _withCtx(() => [
                                            _createElementVNode("i", {
                                                class: _normalizeClass([{ 'search-icon--active': _unref(searchFields).profile }, "icon icon-search-12px"])
                                            }, null, 2)
                                        ]),
                                        _: 2
                                    }, 1032, ["searchTerm", "onUpdate:nameSearch", "onClear:nameSearch"])
                                ]),
                                default: _withCtx(({ row }) => [
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(`${row.profile.name} (${row.client.name})`), 1)
                                ]),
                                _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                                label: _ctx.$t('settings.users.status'),
                                prop: "enabled",
                                "column-key": "status",
                                filters: [
                                    { text: _ctx.$t('settings.users.enabled'), value: 'active' },
                                    { text: _ctx.$t('settings.users.disabled'), value: 'inactive' },
                                ],
                                "filtered-value": _unref(filteredStatusValues),
                                width: "130"
                            }, {
                                header: _withCtx(({ column }) => [
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(column.label), 1)
                                ]),
                                default: _withCtx(({ row }) => [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(['users-list__dot', `users-list__dot--${getUserStatusClass(row.enabled)}`])
                                        }, null, 2),
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(formatStatusLabel(row.enabled)), 1)
                                    ])
                                ]),
                                _: 1
                            }, 8, ["label", "filters", "filtered-value"]),
                            _createVNode(_component_el_table_column, {
                                fixed: "right",
                                width: "60"
                            }, {
                                default: _withCtx(({ row }) => [
                                    _createVNode(_component_el_dropdown, {
                                        trigger: "click",
                                        disabled: isUserToggling(row.id)
                                    }, {
                                        dropdown: _withCtx(() => [
                                            _createVNode(_component_el_dropdown_menu, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_dropdown_item, {
                                                        onClick: ($event) => (openEdit(row))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('edit')), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["onClick"]),
                                                    _createVNode(_component_el_dropdown_item, {
                                                        onClick: ($event) => (_unref(disableUser)(row))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(row?.enabled === 1 ? _ctx.$t('settings.disable') : _ctx.$t('settings.enable')), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["onClick"]),
                                                    _createVNode(_component_el_dropdown_item, {
                                                        onClick: ($event) => (_unref(triggerConfirmModal)(row))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('settings.users.reset-password')), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["onClick"]),
                                                    (row.isLocked)
                                                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                            key: 0,
                                                            onClick: ($event) => (_unref(unlockUserModal)(row))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('settings.users.unlock')), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["onClick"]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ]),
                                        default: _withCtx(() => [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["users-list__table-cell", { 'users-list__table-cell--disabled': isUserToggling(row.id) }])
                                            }, [
                                                (!isUserToggling(row.id))
                                                    ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                                                    : (_openBlock(), _createElementBlock("img", {
                                                        key: 1,
                                                        src: require('@/assets/svgs/loader-circle.svg'),
                                                        class: "users-list__loader-icon"
                                                    }, null, 8, _hoisted_19))
                                            ], 2)
                                        ]),
                                        _: 2
                                    }, 1032, ["disabled"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["data", "default-sort", "class", "onSortChange"]),
                    _createVNode(UserQuestionModal, {
                        error: !!_unref(hasError),
                        loading: _unref(loading)
                    }, null, 8, ["error", "loading"]),
                    _createVNode(UserDialogErrorModal),
                    _createVNode(UserUnlockModal)
                ]),
                (!_unref(loading) && _unref(pagination).count > 0)
                    ? (_openBlock(), _createBlock(ListPagination, {
                        key: 0,
                        data: _unref(pagination),
                        identify: _unref(id),
                        limit: _unref(pagination).limit,
                        "limit-range": [10, 20, 50],
                        "show-list-pages": false,
                        "show-quantity-lines": true
                    }, null, 8, ["data", "identify", "limit"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
